








































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Game } from '../models/simple-war';
import { getAgoTime } from '../utils/utilities';

@Component({
  components: {},
})
export default class GamesListComponent extends Vue {
  @Prop() private games!: Game[];
  @Prop() private title!: string;
  @Prop() private subtitle!: string;
  @Prop() private emptyTitle!: string;
  @Prop() private emptySubtitle!: string;
  @Prop() private isMyGames!: boolean;
  @Prop() private isJoinable!: boolean;
  @Prop() private isCompleted!: boolean;
  @Prop() private showGoToGame!: boolean;

  public goToGame(game: Game) {
    // console.log(`goToGame clicked, gameId=${game.id}`);
    this.$emit('goToGameEvent', game);
  }

  public getAgoTime(dateStr: string, currentStr: string) {
    return getAgoTime(dateStr, currentStr);
  }
}
